import i18next from "i18next";
import { FC } from "react";
import { isExists } from "../../utils";

interface Props {
  source: string | number | any;
  label?: string;
  child?: string;
}

const DateField: FC<Props> = (props) => {
  const locale = i18next.language;
  const { source, child } = props;

  if (source && child) {
    const record = new Date(`${source[child]}`).toLocaleDateString(locale);
    return <div>{record} </div>;
  } else {
    if (!isExists(source)) {
      return <div></div>;
    }
    const record = new Date(`${source}`).toLocaleDateString(locale);

    return <div>{record} </div>;
  }
};

export default DateField;
